import { Splide } from "@splidejs/splide";

export function slide() {
  const initSplide = (selector) => {
    if (document.querySelector(selector)) {
      new Splide(selector, {
        perPage: 1,
        perMove: 1,
        padding: "27%",
        gap: "10%",
        pauseOnHover: false,
        start: 1,
        arrows: false,
        pagination: false,
      }).mount();
    }
  };


  const handleSplide = () => {
    [".splide01", ".splide02"].forEach(selector => {
      initSplide(selector);
      // window.addEventListener("resize", () => resizeSplide(selector));
    });
  };

  handleSplide();
}
